import Echo from "laravel-echo";
import Pusher from "pusher-js";

(window as any).Pusher = Pusher;

let echo: Echo<any> | null = null;

export const createEcho = (token: string) => {
  if (echo) return echo;

  
  // const baseUrl = (process.env.REACT_APP_BACKEND_URL || "")
  //   .replace(/\s+/g, "")
  //   .replace(/\/+$/, "");
  // Broadcasting auth is registered at the domain root (POST /broadcasting/auth),
  // not under the versioned API prefix, so use the backend's origin only.
  const rawBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\s+/g, "");
  const baseUrl = rawBackendUrl ? new URL(rawBackendUrl).origin : "";

  echo = new Echo({
    broadcaster: "pusher",
    key: "51e1576fcf81e7f95687",
    cluster: "mt1",
    forceTLS: true,
    encrypted: true,
    authEndpoint: `${baseUrl}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    namespace: "App.Modules.Client.Events",
  });

  return echo;
};

export const disconnectEcho = () => {
  if (echo) {
    echo.disconnect();
    echo = null;
  }
};
